/* BCF v7.2 — reveal + diegetic motion module (SPEC §4) + grid filter tabs.
   Reduced-motion guard ported verbatim from the mockup: RM early-returns
   every diegetic routine; CSS @media blocks handle the static fallbacks. */
(function () {
  document.body.classList.add('bcf-js');

  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function eOut(t) { return 1 - Math.pow(1 - t, 3); }

  /* ---------- reveal (.rv) — the one fade-up, used sparingly ---------- */
  var io;
  function reveal() {
    var els = document.querySelectorAll('.bcf .rv:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- scale settles (weigh ticket) ---------- */
  function settleScale(el) {
    var m = el.textContent.match(/([\d.]+)/);
    if (!m) return;
    var target = parseFloat(m[1]), over = +(target * 1.06).toFixed(1), t0 = null, D1 = 460, D2 = 270;
    function step(ts) {
      if (!t0) t0 = ts;
      var e = ts - t0;
      if (e < D1) { el.textContent = (over * eOut(e / D1)).toFixed(1) + ' g'; requestAnimationFrame(step); }
      else if (e < D1 + D2) { var p = (e - D1) / D2; el.textContent = (over + (target - over) * p).toFixed(1) + ' g'; requestAnimationFrame(step); }
      else { el.textContent = target.toFixed(1) + ' g'; }
    }
    requestAnimationFrame(step);
  }

  /* ---------- fix ticker flips once ---------- */
  function rollFix(el) {
    var m = el.textContent.match(/([\d.]+)/);
    if (!m) return;
    var target = parseFloat(m[1]), start = target - 0.7, t0 = null, D = 680;
    el.classList.add('flip-roll');
    function step(ts) {
      if (!t0) t0 = ts;
      var e = Math.min(1, (ts - t0) / D), v = start + (target - start) * eOut(e);
      el.textContent = '$' + v.toFixed(2) + '/g';
      if (e < 1) requestAnimationFrame(step); else el.textContent = '$' + target.toFixed(2) + '/g';
    }
    requestAnimationFrame(step);
  }

  /* ---------- hero / rung videos ---------- */
  function initHeroVideo() {
    var vids = [].slice.call(document.querySelectorAll('.bcf video[data-loop]'));
    vids.forEach(function (v) {
      if (RM) { try { v.pause(); } catch (e) {} return; }
      v.muted = true;
      var p = v.play();
      if (p && p.catch) { p.catch(function () {}); }
    });
  }

  /* ---------- diegetic init (RM early-returns, per SPEC §4) ---------- */
  function initDiegetic() {
    var fix = document.getElementById('fix-g');
    if (fix && !RM) { rollFix(fix); }
    if (RM) { return; }
    var supportsIO = ('IntersectionObserver' in window);
    var wt = document.querySelector('.bcf .wticket .rd');
    if (wt) {
      if (supportsIO) {
        var so = new IntersectionObserver(function (en) {
          en.forEach(function (x) {
            if (x.isIntersecting) { settleScale(x.target); so.unobserve(x.target); }
          });
        }, { threshold: 0.6 });
        so.observe(wt);
      } else { settleScale(wt); }
    }
    var stamps = document.querySelectorAll('.bcf .hallmark');
    if (!supportsIO) { stamps.forEach(function (h) { h.classList.add('struck'); }); return; }
    var ho = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('struck'); ho.unobserve(x.target); }
      });
    }, { threshold: 0.45 });
    stamps.forEach(function (h) { ho.observe(h); });
  }

  /* ---------- grid filter tabs (server-rendered panels, client toggle) ---------- */
  function initTabs() {
    document.querySelectorAll('.bcf [data-bcf-tabs]').forEach(function (wrap) {
      var btns = wrap.querySelectorAll('.tabs button[data-panel]');
      var panels = wrap.querySelectorAll('.bcf-grid-panel');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          panels.forEach(function (p) { p.hidden = p.dataset.panel !== b.dataset.panel; });
          reveal();
        });
      });
    });
  }

  /* ---------- homepage CTA path (defensive against stale theme-editor HTML) ---------- */
  function initHeroNavigation() {
    var cta = document.querySelector('.bcf .hero .cta');
    if (!cta) return;
    var primary = cta.querySelector('.btn.gold');
    if (primary && primary.textContent.trim() === 'Shop Everyday Silver') {
      primary.setAttribute('href', '#grid');
    }
    cta.querySelectorAll('.tlink').forEach(function (link) {
      if (/Start with silver/i.test(link.textContent)) link.remove();
    });
  }

  function init() {
    initHeroNavigation();
    reveal();
    initTabs();
    initHeroVideo();
    initDiegetic();
    setTimeout(function () {
      document.querySelectorAll('.bcf .rv:not(.in)').forEach(function (e) { e.classList.add('in'); });
    }, 1400);
    window.addEventListener('load', reveal);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
